// extracted by mini-css-extract-plugin
export default {"popup_wrap":"createAddressError_popup_wrap__IRlGk","popup_message":"createAddressError_popup_message__tvlu-","popup_message_button":"createAddressError_popup_message_button__ERh9x"};